import { Minion } from '../../domain/minion.js';
import { Projectile } from '../../domain/projectile.js';

/**
 * stressSpawn — Domain-only entity factories for perf / stress scenarios.
 */

export function createStressMinions({
  count = 0,
  team = 'red',
  origin = { x: 0, z: 0 },
  idPrefix = 'stress-minion'
} = {}) {
  const n = Math.max(0, Math.floor(count));
  const list = [];
  for (let i = 0; i < n; i += 1) {
    list.push(new Minion({
      id: `${idPrefix}-${i}`,
      team,
      minionType: i % 3 === 0 ? 'ranged' : 'melee',
      x: (origin.x || 0) + (i % 10) * 1.2,
      z: (origin.z || 0) + Math.floor(i / 10) * 1.2
    }));
  }
  return list;
}

export function createStressProjectiles({
  count = 0,
  source = null,
  target = null,
  idPrefix = 'stress-proj'
} = {}) {
  const n = Math.max(0, Math.floor(count));
  const list = [];
  for (let i = 0; i < n; i += 1) {
    list.push(new Projectile({
      id: `${idPrefix}-${i}`,
      sourceEntity: source,
      targetEntity: target,
      type: 'auto',
      speed: 1200,
      damage: 1
    }));
  }
  return list;
}
